import React, { useCallback } from 'react';
import SubscribeButton from '@/creditflowresearch/ui/common/components/SubscribeButton';
import {
  ISubscribeBySSIDPayload,
  useSubscribeBySSID,
} from '@/creditflowresearch/application/Subscriptions/useSubscribeBySSID';

type TSubscribeButtonProps = React.ComponentProps<typeof SubscribeButton>;

interface ISubscribeButtonContainerProps extends Omit<TSubscribeButtonProps, 'isFetching' | 'subscribeBySSID'> {
  onSubscribed?: () => void,
}

const SubscribeButtonContainer = ({ onSubscribed, ...props }: ISubscribeButtonContainerProps) => {
  const { isFetching, subscribeBySSID } = useSubscribeBySSID();

  const subscribe = useCallback((payload: ISubscribeBySSIDPayload, onSuccess?: () => void) => (
    subscribeBySSID(payload, () => {
      onSuccess?.();
      onSubscribed?.();
    })
  ), [subscribeBySSID, onSubscribed]);

  return (
    <SubscribeButton
      { ...props }
      isFetching={ isFetching }
      subscribeBySSID={ subscribe }
    />
  );
};

export default SubscribeButtonContainer;
